import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule, MatButtonModule } from '@angular/material';
import { ExtendzApiTableHostComponent } from './extendz-api-table-host.component';
import { ExtendzApiTableModule } from '../api-table/extendz-api-table.module';
var ExtendzApiTableHostModule = /** @class */ (function () {
    function ExtendzApiTableHostModule() {
    }
    ExtendzApiTableHostModule = tslib_1.__decorate([
        NgModule({
            imports: [
                CommonModule,
                // Extendz
                ExtendzApiTableModule,
                // Mat
                MatIconModule,
                MatButtonModule
            ],
            declarations: [ExtendzApiTableHostComponent],
            exports: [ExtendzApiTableHostComponent]
        })
    ], ExtendzApiTableHostModule);
    return ExtendzApiTableHostModule;
}());
export { ExtendzApiTableHostModule };
//# sourceMappingURL=extendz-api-table-host.module.js.map